// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dda23872","732":"9dbdb74e","977":"aae44748"}[chunkId] + ".chunk.js";
};